import * as React from 'react';
import { useSelector } from 'react-redux';
import { MVKPreloader as MVKPreloaderComponent } from '../../components/MVKPreloader';
import { getDisplayName } from '../../selectors/newbuilding';
import { getNearbyNewbuildingsMapUrl } from '../../selectors/newbuilding/getNearbyNewbuildingsMapUrl';
import { getServerMvkData } from '../../selectors/newbuilding/getServerMvkData';

export const MVKPreloader = () => {
  const mvkServerData = useSelector(getServerMvkData);
  const name = useSelector(getDisplayName);
  const link = useSelector(getNearbyNewbuildingsMapUrl);

  return <MVKPreloaderComponent mvkData={mvkServerData} name={name} link={link} />;
};

MVKPreloader.displayName = 'MVKPreloader';
